import { ImgStatusEnum } from 'enum/uploadImg-status.enum'
import I18n from 'i18n'

export const validate = ({ name, description }: any) => {
  //const errors: FormErrors<ICourseModel> = {};
  const errors = {
    name: '',
    description: '',
    banner: '',
    thumbnail: '',
    courseType: '',
    startDate: '',
    untilDate: '',
    optionalProfiles: '',
    requiredProfiles: '',
    state: '',
    sendEmail: '',
    invitationNotification: '',
    lessons: '',
    hasStarted: '',
  }

  if (!name) {
    errors.name = I18n.t('administration.courses.new.form.validations.name.required')
  }

  if (!description) {
    errors.description = I18n.t('administration.courses.new.form.validations.description.required')
  }

  return errors
}

export const imgFileValidate = (file: any) => {
  console.log('validating image')
  let img: any = undefined
  img = new Image()
  return new Promise((resolve: any) => {
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      img.src = URL.createObjectURL(file)
      img.onload = function () {
        if (file.size > 10000000) {
          resolve(ImgStatusEnum.maxSizeExceeded)
        } else {
          resolve(ImgStatusEnum.success)
        }
      }
    } else {
      resolve(ImgStatusEnum.wrongFileType)
    }
  })
}
